import { FC, useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { validate, VALIDATOR_MAXLENGTH, VALIDATOR_REQUIRE } from '../helpers/Validators';
import { RootState } from '../redux/store';
import { nickNameIsAvailable } from '../services/accountService';
import { VALIDATOR_MINLENGTH } from './../helpers/Validators';
import { GenderType } from '../helpers/Enums';

export type EditNickNameProps = {
    onSave: (value: string) => void;
    value: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    buttonText: string
}

const EditNickName: FC<EditNickNameProps> = ({ onSave, value, title, subtitle, buttonText }) => {
    const [nickname, setNickname] = useState<string>("");
    const [errors, setErrors] = useState<any>({});
    const history = useHistory();
    const resgiter = useSelector((state: RootState) => state.signup);
    const member = useSelector((state: RootState) => state.member);
    const [genderId, setGenderId] = useState<number>(resgiter.genderId);

    useEffect(() => {
        if (member.memberCode === 0) {
            if (resgiter.genderId === 0) {
                setGenderId(5);
            } else {
                setGenderId(resgiter.genderId);
            }
        } else {
            setGenderId(member.genderId);
        }
        if (value) setNickname(value);
    }, [])

    const validateForm = async () => {
        let errors: any = {};
        if (!validate(nickname, [VALIDATOR_REQUIRE()])) {
            errors["nickname"] = "חובה להזין כינוי";
        }
        if (!validate(nickname, [VALIDATOR_MINLENGTH(3)])) {
            errors["nickname"] = "השם או הכינוי צריכים לכלול לפחות 3 תווים";
        }
        if (!validate(nickname, [VALIDATOR_MAXLENGTH(20)])) {
            errors["nickname"] = "השם או הכינוי לא יכול להיות ארוך יותר מ-20 תווים";
        }
        if (!await validateNickNameOnServer(nickname)) {
            errors["nickname"] = genderId === GenderType.MALE ? "נראה שהשם הזה תפוס. אפשר לבחור שם חדש או להוסיף לשם שבחרת אותיות או מספרים (למשל משה22)" : "נראה שהשם הזה תפוס. אפשר לבחור שם חדש או להוסיף לשם שבחרת אותיות או מספרים (למשל רות22)";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateNickNameOnServer = async (nickName: string) => {
        const { data }: any = await nickNameIsAvailable(nickName);
        return data;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (await validateForm()) {
            onSave(nickname);
        }
    };

    const enabled =
        nickname.length > 0;

    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{title}</h2>
                    <div>{subtitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form_field_content login">
                            <div className="field_block">
                                <input autoComplete="off" name="nickname" type="text" value={nickname} placeholder='השם שלך' onChange={e => {
                                    setErrors({})
                                    setNickname(e.target.value)
                                }} maxLength={256} className="txt_field name w-input" />
                                <div className="form_allert" style={{ display: errors && errors["nickname"] ? "contents" : "block" }}>{errors["nickname"]}</div>
                                {/* <div className="field_block_comment">כאן יש להכניס שם פרטי או כינוי.שם זה ייצג אותך בקהילה</div> */}
                                <br />
                            </div>
                            <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                        </div>
                        {/* <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full send w-button"}></input> */}
                    </form>
                </div>
            </div>
        </>
    )
}

export default EditNickName